/**
 * Normalize Topic meta.pageCopy for ToolPageCopy — supports legacy
 * { title, copy } blocks and modern typed blocks.
 */

export function isGuideHowToBlock(block) {
  if (!block) return false;
  const title = String(block.title || '').trim().toLowerCase();
  return block.type === 'ordered-list' && title.includes('how to use this guide');
}

export function normalizeTopicPageCopy(raw, name = '') {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    const blocks = [];
    const legacyPairs = [];

    for (const b of raw) {
      if (!b || typeof b !== 'object') continue;
      const type = String(b.type || '').trim();
      if (type) {
        blocks.push({ ...b, type });
        continue;
      }
      const title = String(b.title || '').trim();
      const copy = String(b.copy || '').trim();
      if (title && copy) legacyPairs.push({ q: title, a: copy });
    }

    if (legacyPairs.length) {
      legacyPairs.forEach(({ q, a }) => {
        blocks.push({
          type: 'section',
          title: q.replace(/\?$/, ''),
          copy: a,
        });
      });
    }

    return blocks;
  }

  return [];
}

export function buildFaqJsonLd(pageCopyBlocks) {
  const faqBlock = (pageCopyBlocks || []).find((b) => b?.type === 'faq');
  const items = Array.isArray(faqBlock?.items) ? faqBlock.items : [];
  const qa = items
    .map((row) => {
      const q = String(row?.q || row?.question || '').trim();
      const a = String(row?.a || row?.answer || '').trim();
      if (!q || !a) return null;
      return {
        '@type': 'Question',
        name: q,
        acceptedAnswer: { '@type': 'Answer', text: a },
      };
    })
    .filter(Boolean);

  if (!qa.length) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: qa,
  };
}
